import {getGETS} from "@js/globalFunctions/getGets";

export function handleFreeTextQueryTracking()
{
	var gets = getGETS();
	if( typeof gets['freeTextQuery'] !== 'undefined' && gets['freeTextQuery'] === 'true' && typeof gets['label'] !== 'undefined' && typeof gets['query'] !== 'undefined' )
	{
		var query = decodeURIComponent( gets['query'] ).trim();
		var label = decodeURIComponent( gets['label'] ).trim();
		if( query !== '' && label !== '' && query.length > 2 )
		{
			fireFreeTextFormDatalayerTracking(query, label);
		}
	}
}

function fireFreeTextFormDatalayerTracking( query, label )
{
	console.log('query sent: '+ query + ' - ' + label);
	label = ( typeof label !== 'undefined' ) ? label : '' ;
	query = ( typeof query !== 'undefined' ) ? query : $('#freeSearchInputField').val();
	dataLayer.push({
		event: 'serverEvent',
		eventCategory: 'site search',
		eventAction: query,
		eventLabel: label
	});
}
